var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tacenter"},[_c('div',{staticClass:"menu_title"},[_c('p',{staticClass:"title_english"},[_vm._v(_vm._s(_vm.englishText))]),_c('div',{staticClass:"title_chinese"},[_vm._v(_vm._s(_vm.positiveTitle))])]),_c('div',{staticClass:"menu_subheading"},[_vm._v(_vm._s(_vm.subheading))])])
}
var staticRenderFns = []

export { render, staticRenderFns }